import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedChargingAssessment, VoltageSpeedDashboardSample, VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { buildDailyInsights } from './daily-insights.utils';

@Component({
  selector: 'app-voltage-speed-daily-insights',
  templateUrl: './daily-insights.component.html',
  styleUrls: ['./daily-insights.component.css']
})
export class VoltageSpeedDailyInsightsComponent implements OnChanges {
  @Input() summary: VoltageSpeedDashboardSummary | null = null;
  @Input() samples: VoltageSpeedDashboardSample[] = [];
  @Input() assessment: VoltageSpeedChargingAssessment | null = null;

  view = buildDailyInsights(null, [], null);

  ngOnChanges(): void {
    this.view = buildDailyInsights(this.summary, this.samples, this.assessment);
  }
}
